// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_BuscaStatusDespesasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /despesas/buscaStatusDespesas
 *
 * Returns a list of expense status options for dropdowns/selects.
 * Each status has an ID (Valor) and a translated label (Nome).
 *
 * @see Despesas_Status_Model::selectStatusDespesas() for the source data
 */
import type { Despesas_BuscaStatusDespesasRow } from './Despesas_BuscaStatusDespesasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_BuscaStatusDespesasResponseDados = Despesas_BuscaStatusDespesasRow[];

export type Despesas_BuscaStatusDespesasResponse = ApiResponse<Despesas_BuscaStatusDespesasResponseDados>;

registerResponseContract('Despesas_BuscaStatusDespesasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      Valor: { type: 'number',  required: true },
      Nome:  { type: 'string',  required: true },
    },
  },
})
